import { stepTypes } from "./constants";

export const actionTypes = {
  STEP_SUBMITTED: "STEP_SUBMITTED",
  STEP_CHANGED: "STEP_CHANGED",
  FLOW_SUBMIT_SUCCESS: "FLOW_SUBMIT_SUCCESS",
  FLOW_SUBMIT_START: "FLOW_SUBMIT_START",
  FLOW_SUBMIT_ERROR: "FLOW_SUBMIT_ERROR",
  FLOW_INIT: "FLOW_INIT"
};

export const initialState = {
  isSubmitting: false,
  isSubmitted: false,
  isSubmitErroneous: false,
  steps: []
};

/**
 * Selectors
 */
export const getIsSubmitting = state => state.isSubmitting;

export const getIsSubmitted = state => state.isSubmitted;

export const getIsPristine = state =>
  state.steps.every(step => !step.isSubmitted);

export const getFirstUnsubmittedStep = state =>
  state.steps.find(step => !step.isSubmitted);

export const getHasSteps = state => state.steps.length > 0;

export const getFormSteps = state =>
  state.steps.filter(step => step.type === stepTypes.FORM);

export const getStepLength = state => state.steps.length;

export const getIndexById = (state, id) =>
  state.steps.findIndex(step => step.id === id);

export const getNextStepById = (state, id) =>
  state.steps[getIndexById(state, id) + 1];

export const getReviewStepId = state =>
  state.steps.find(step => step.type === stepTypes.REVIEW).id;

export const getStepById = (state, id) =>
  state.steps.find(step => step.id === id);

export const getStepsUntilAndIncludingFirstUnsubmitted = state => {
  const firstUnsubmittedStep = getFirstUnsubmittedStep(state);

  if (firstUnsubmittedStep) {
    const firstUnsubmittedIndex = getIndexById(state, firstUnsubmittedStep.id);
    return state.steps.slice(0, firstUnsubmittedIndex + 1);
  } else {
    return null;
  }
};

/**
 * Reducer utils
 */
export const setStepSubmittedStatus = (
  state,
  { id, renderedFormData },
  status
) => {
  const nextSteps = state.steps.map(step => {
    if (step.id === id) {
      return {
        ...step,
        renderedFormData,
        isSubmitted: status
      };
    } else {
      return step;
    }
  });
  return {
    ...state,
    steps: nextSteps
  };
};

export const setStepChanged = (state, { id, formData }) => {
  const nextSteps = state.steps.map(step => {
    if (step.id === id) {
      return {
        ...step,
        formData,
        isSubmitted: false
      };
    } else {
      return step;
    }
  });
  return {
    ...state,
    steps: nextSteps
  };
};

export const setFlowSubmitted = state => {
  return {
    ...state,
    isSubmitting: false,
    isSubmitted: true
  };
};

export const setSubmitting = state => {
  return {
    ...state,
    isSubmitErroneous: false,
    isSubmitting: true
  };
};

export const setSubmitError = state => {
  return {
    ...state,
    isSubmitErroneous: true,
    isSubmitting: false
  };
};

export const setSteps = (state, payload) => ({
  ...state,
  steps: payload
});

/**
 * Reducer
 */
export default (state, { type, payload }) => {
  let next;

  switch (type) {
    case actionTypes.STEP_SUBMITTED:
      next = setStepSubmittedStatus(state, payload, true);
      break;
    case actionTypes.STEP_CHANGED:
      next = setStepChanged(state, payload);
      break;
    case actionTypes.FLOW_SUBMIT_START:
      next = setSubmitting(state);
      break;
    case actionTypes.FLOW_SUBMIT_ERROR:
      next = setSubmitError(state);
      break;
    case actionTypes.FLOW_SUBMIT_SUCCESS:
      next = setFlowSubmitted(state);
      break;
    default:
      next = state;
      break;
  }
  return next;
};
